import {Component,Inject,Input,OnDestroy,OnInit,PLATFORM_ID,ViewChild,} from "@angular/core";
import { Store } from "@ngrx/store";
import { Router } from "@angular/router";
import { _seoContent } from "@app/marketplace/seo-content/utils";
import { Observable } from "rxjs";
import * as selectors from "../state/product-details/details-selectors";
import * as actions from "../state/product-details/details-actions";
import * as relatedActions from '@app/marketplace/products/state/related-product/related-actions';
import { Utils } from "@app/marketplace/core/helpers/utils";
@Component({
  selector: "app-product-dimensions",
  templateUrl: "./product-dimensions.component.html",
  styleUrls: ["./product-dimensions.component.css"],
})
export class ProductDimensionsComponent  implements OnInit, OnDestroy {
  @Input() provider:number;
  dimensions$ :Observable<any>;
  currentKey$ :Observable<any>;
  constructor(private store: Store<any>,private router: Router,) {
    this.dimensions$ = this.store.select(selectors.selectDimensions);
    this.currentKey$= this.store.select(selectors.selectCurrentKey);
  }
  ngOnInit(): void {;}
  public getDetails(product:string) {
   if(!product) return;
   var provider=Utils.GetProviderName(this.provider);
   let currentUrl = `/market/productos-compras-cuba-online/${provider}/${product}`;
   this.router.navigateByUrl(currentUrl, {skipLocationChange: true}).then(() => {
     this.store.dispatch(actions.LoadingProductDetailAction());
     this.store.dispatch(relatedActions.ResetRelatedProductsAction());
   });
  }
  ngOnDestroy(): void {;}
}
